import {Box, Slider, Typography} from '@material-ui/core';
import styled from 'styled-components';
import React from 'react';

const ImageContainer = styled(Box)`
  width: 100%;
  height: 100%;
  max-height: 215px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img<{zoom: number}>`
  max-height: 100%;
  width: 100%;
  object-fit: none;
  zoom: ${props => props.zoom + '%'};
  filter: drop-shadow(0.5px 0.5px 0.5px #545454);
`;

interface ImageViewerProps {
  src: string | null;
  title: string;
  zoom: number;
  onZoomChange: (value: number) => void;
}

const ImageViewer = ({src, title, zoom, onZoomChange}: ImageViewerProps) => {
  if (!src) return null;

  return (
    <>
      <Typography variant="subtitle1" color="primary">
        {title}
      </Typography>
      <ImageContainer>
        <Image src={src} alt={title} zoom={zoom} />
      </ImageContainer>
      <Slider value={zoom} onChange={(e, v) => onZoomChange(v as number)} min={100} max={750} />
    </>
  );
};

export default ImageViewer;
